module.exports = __webpack_public_path__ + "static/media/menu_white.9fafd00f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./media/menu_white.png
 ** module id = 259
 ** module chunks = 0
 **/